import { render, staticRenderFns } from "./DoubleAngleRightSvg.vue?vue&type=template&id=1c7bf778&scoped=true&"
import script from "./DoubleAngleRightSvg.vue?vue&type=script&lang=js&"
export * from "./DoubleAngleRightSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7bf778",
  null
  
)

export default component.exports